import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const PseudoIcon = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.625 13.1034H11.4375M11.4375 13.1034H14.25M11.4375 13.1034V15.9483M11.4375 13.1034V10.2586",
      stroke: color,
      strokeWidth: "1.5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.375 4H5.0625C4.23407 4 3.5625 4.67157 3.5625 5.5V6.84483",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.375 19.931H5.0625C4.23407 19.931 3.5625 19.2595 3.5625 18.431V17.0862",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.625 19.931H18.9375C19.7659 19.931 20.4375 19.2595 20.4375 18.431V17.0862",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.4375 10.2586L20.4375 8.91379C20.4375 8.08536 19.7659 7.41379 18.9375 7.41379L17.625 7.41379",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.375 7.41379H14.3138C13.9131 7.41379 13.5289 7.2534 13.2471 6.96838L12.5625 6.27586",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.4375 5.13793L10.7529 4.44542C10.4711 4.1604 10.0869 4 9.68615 4H8.625",
      stroke: color,
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.5 12H21.5V15H19.5V12Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.5 12.5H4.5V15.5H2.5V12.5Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.5 8H4.5V11H2.5V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 19H15.5V21H13V19Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 19H11V21H8V19Z",
      fill: color
    })]
  });
};
export { PseudoIcon };